<template>
  <v-container id="info" class="text-center pb-15">
    <v-row>
      <v-col>
        <!-- <v-btn
          size="x-large"
          rounded="xl"
          :href="$t('info.link')"
          target="_blank"
          class="text-body-1 bg-transparent px-10"
          style="border: 2px solid white; color: white; text-transform: none"
        >
          <v-img
            :src="iconPath"
            dark
            left
            large
            class="mr-3"
            width="30"
            style="filter: brightness(0) invert(1);"
          ></v-img>
          {{ $t("info.button") }}
        </v-btn> -->
      </v-col>
    </v-row>
  </v-container>
</template>



<script setup>
import { ref, computed, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import LocaleData from "@/locales/InforMation";
import { getBasePath } from '@/utils/basePath';

const { t, locale } = useI18n();
const localizedData = computed(() => LocaleData[locale.value]);

// ベースパスを取得
const basePath = computed(() => getBasePath());

// 画像パスを構築
const iconPath = computed(() => `${basePath.value}${t('info.icon')}`);

// スクロールイベントのハンドラ
const onScroll = (event) => {
  // スクロールイベントに対する処理をここに記述
  console.log("scrolling", event);
};

// Twitterタイムライン関連のコードは削除（このコンポーネントでは使用しない）
</script>

<style lang="scss" scoped>
#twitter-timeline-container {
  max-height: 300px;
  overflow-y: auto;
  @media screen and (min-width: 600px) {
    max-height: 500px;
  }
  @media screen and (min-width: 960px) {
    max-height: 600px;
  }
  @media screen and (min-width: 1200px) {
    max-height: 700px;
  }
}
#twitter-timeline {
  max-width: 600px;
  margin: 0 auto;
}
</style>